import { render, staticRenderFns } from "./diet-advice.vue?vue&type=template&id=6be13155&scoped=true&"
import script from "./diet-advice.vue?vue&type=script&lang=js&"
export * from "./diet-advice.vue?vue&type=script&lang=js&"
import style0 from "./diet-advice.vue?vue&type=style&index=0&id=6be13155&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be13155",
  null
  
)

export default component.exports